export default {
  titles: {
    default: 'Herinnering geplande bestelling!',
    external_delivery: 'Bezorger toegewezen!',
  },
  labels: {
    pickup: 'Afhalen: {{time}}',
    serve: 'Serveren: {{time}}',
    preparation_time: 'Bereidingstijd: {{time}} min',
  },
  buttons: {
    confirm: 'Begin nu met bereiden',
    print_and_confirm: 'Afdrukken & nu bereiden',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan, probeer het opnieuw',
  },
};
